export function isAttributeStart(char: string): boolean {
  return char !== '='
}
